import { CHeaderNav } from '@coreui/react-pro'
import { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import MenuIcon from '@mui/icons-material/Menu';
import { IconButton } from '@mui/material'
import { CHeading1 } from 'src/components/coreUIMimicComponent'
import { ThemeContext } from 'src/context/ThemeContext'
import { BusinessProfileContext } from '../context/BusinessProfileContext'
import {
  BusinessAppHeaderParent,
  CompanyDetailsContainer,
  ProfileRelatedWidget,
} from './AppHeaderStyles'
import { BusinessHeader } from './styledComponents'
import { selectSidebarShow, selectTheme, setSidebarShow } from '../reducers/layoutReducer'

const AppHeader = ({ heading, userName }) => {
  const dispatch = useDispatch()
  const { theme } = useContext(ThemeContext)
  const { profileData, businessCustomerDetails, businessCustomerPersonalDetails } =
    useContext(BusinessProfileContext)

  const reduxTheme = useSelector(selectTheme)

  reduxTheme === 'dark'
    ? document.body.classList.add('dark-theme')
    : document.body.classList.remove('dark-theme')

  const sidebarShow = useSelector(selectSidebarShow)

  return (
    <BusinessHeader themeType={theme}>
      <CHeaderNav className="w-full">
        <BusinessAppHeaderParent>
          <div className="d-flex justify-content-start align-items-start gap-4">
            <IconButton onClick={() => dispatch(setSidebarShow(!sidebarShow))}>
              <MenuIcon sx={{ color: theme === 'dark' ? 'white' : 'black' }} />
            </IconButton>
            <CompanyDetailsContainer>
              <CHeading1 className="text-textHeading dark:text-white font-bold">
                {businessCustomerDetails?.companyName}
              </CHeading1>
              <span className="font-normal text-lg dark:text-white -mb-1">{heading}</span>
            </CompanyDetailsContainer>
          </div>
          <ProfileRelatedWidget themeType={theme} />
        </BusinessAppHeaderParent>

        {/* <div className="w-full flex flex-row mt-4 px-16 items-center justify-between">
            <div className="flex xl:flex-row lg:flex-col items-center xl:gap-3">
              <h1 className="text-textHeading dark:text-white font-bold">{businessCustomerDetails?.companyName}</h1>
              <span className="font-normal text-lg dark:text-white -mb-1">{heading}</span>
            </div>
            <div className="flex flex-row-reverse gap-2 items-center">
              <AppHeaderDropdownNotif />
              <AppHeaderDropdown />
              <ThemeToggle />
            </div>
          </div> */}
      </CHeaderNav>
    </BusinessHeader>
  )
}

export default AppHeader
